module.exports = ['$scope', 'Playlist', function MyPlaylistModalEditCtrl($scope, Playlist) {
    "use strict";

    $scope.playlist = $scope.playlist || {};

    $scope.submit = function(playlist) {
        var $playlist = new Playlist(playlist);

        $scope.isLoading = true;

        $playlist.$save(function(response) {

            //when creating a new playlist, the playlist is returned
            if (response.data) {
                playlist = response.data;
            }

            $scope.$close(true, playlist);
        }, function(response) {
            $scope.isLoading = false;
            $scope.errors    = response.errors;
        });
    };
}];



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/controllers/MyPlaylistModalEditCtrl.js